import gql from 'graphql-tag';
import { uploadImage } from './uploadImage';

const updateLocationMutation = gql`
  mutation updateLocation(
    $id: ID!
    $name: String!
    $address: String!
    $address2: String
    $city: String!
    $postCode: String!
    $imageKey: String!
    $digiticketsCatId: String
    $description: String!
  ) {
    data: updateLocation(
      id: $id
      name: $name
      address: $address
      address2: $address2
      city: $city
      postCode: $postCode
      digiticketsCatId: $digiticketsCatId
      imageKey: $imageKey
      description: $description
    ) {
      id
      name
      address
      address2
      city
      postCode
      digiticketsCatId
      image {
        url
      }
      description
      createdAt
      updatedAt
    }
  }
`;

export const updateLocation = async ({ client, params }) => {
  // ImageKey already present
  if (params.data.image.rawFile) {
    params.data.imageKey = await uploadImage(client, params);
  } else {
    params.data.imageKey = params.data.image.url;
  }

  const result = await client.mutate({
    mutation: updateLocationMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
